export default {
  data() {
    return {};
  },

  mounted() {
    window.document.title = 'SITC Pilipinas Appointment System';
  }

};